import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/reset.css';
import './LoginBodecom.css';
import logoBodecom from '../../assets/bodecom.png';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../store/auth/authSlice';

const LoginBodecom = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState(''); // Nuevo state para OTP
    const [attemptedLogin, setAttemptedLogin] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Incluimos twoFactorRequired del state de autenticación



    const { loading, user, applications, error, twoFactorRequired, is_group5, isAuthenticated } =
        useSelector((state) => state.auth);
    const isGroup5 = Boolean(user?.is_group5 ?? is_group5);


    useEffect(() => {

        if (user && user.username && isAuthenticated) {
            if (!applications || applications.length === 0) {
                message.warning('El usuari@ no tiene aplicaciones asignadas.', 5);
            }
            message.success('Bienvenid@ UTF COL 188 COL!');
            navigate(isGroup5 ? '/planOperativo' : '/inicio', { replace: true });
        } else if (attemptedLogin && error) {
            message.error('Error en la autenticación del usuario.', 5);
        }

    }, [user, isAuthenticated, isGroup5, error, navigate, attemptedLogin, applications]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setAttemptedLogin(true);
        // Si se requiere OTP, incluye otp en la acción
        if (twoFactorRequired) {
            dispatch(login({ username, password, otp }));
        } else {
            dispatch(login({ username, password }));
        }
    };


    return (
        <div className="login-background">
            <Container className="login-container d-flex justify-content-end align-items-center">
                <Row>
                    <Col md={4} className="login-form-wrapper">
                        <div className="login-form-box">
                            <img
                                src={logoBodecom}
                                alt="Bodecom Logo"
                                className="logo pb-3"
                                width={250}
                            />
                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="formBasicUsername">
                                    <Form.Label className="titleLabel">Usuario *</Form.Label>
                                    <Input
                                        type="text"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        placeholder="Digite usuario"
                                        className="mb-3"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="formBasicPassword">
                                    <Form.Label className="titleLabel">Clave *</Form.Label>
                                    <Input.Password
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Digite contraseña"
                                        className="mb-3"
                                        required
                                    />
                                </Form.Group>

                                {/* Renderizamos el input para OTP solo si se requiere 2FA */}
                                {twoFactorRequired && (
                                    <Form.Group controlId="formBasicOTP">
                                        <Form.Label className="titleLabel">Código de autenticación *</Form.Label>
                                        <Input
                                            type="text"
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value)}
                                            placeholder="Ingrese el código OTP"
                                            className="mb-3"
                                            required
                                        />
                                    </Form.Group>
                                )}

                                <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                                    {loading
                                        ? 'Iniciando sesión...'
                                        : twoFactorRequired
                                            ? 'Verificar código'
                                            : 'Iniciar sesión'}
                                </Button>
                            </Form>
                            <h2 className="text-center mt-2">Bienvenid@</h2>
                            <h4 className="text-center">
                                <a
                                    href="https://www.fao.org/colombia/es/"
                                    className="no-decoration-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    www.fao.org
                                </a>
                            </h4>
                            <hr />
                            <h6 className="text-center">soporte@comunix.co</h6>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LoginBodecom;
